<template>
  <div class="posters">
    <img
      src="@/assets/images/posters.jpg"
      alt=""
      class="imgStyle"
    />
  </div>
</template>
<script>
export default {
  name: 'posters',
  data() {
    return {
    };
  },
};
</script>
<style  scoped>
.imgStyle {
  width: 100%;
}
</style>
